import React, { useState, useEffect, useMemo } from 'react'
import Swal from 'sweetalert2'
import { useHistory, useParams } from 'react-router'
import { Container, Grid, TextField, Button, FormGroup, FormControlLabel, Checkbox } from '@material-ui/core'
import { Autocomplete } from '@mui/material';
import { Refresh } from '@material-ui/icons'
import { settingAPI } from './../services/SettingService'
import { Formik, Form } from "formik";
import { useDropzone } from "react-dropzone";
import * as Yup from "yup";

const Setting_Edit_Template = () => {
    let history = useHistory()
    const { _id } = useParams()
    const token = localStorage.getItem("Token")
    const [data, setData] = useState(null)
    const [type, setType] = useState([])
    const [force, setForce] = useState(0)
    const FormSchema = Yup.object().shape({
        template_file_show: Yup.string()
            .trim()
            .required("*ใส่ชื่อไฟล์ด้วย"),
    });
    useEffect(() => {
        settingAPI.getTemplateByID(token, _id)
            .then((res) => {
                if (res.status == 200) {
                    setData(res.message)
                    document.title = `Com7 Merchandise - ${res.message.template_file_show}`
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${res.message}</span>`,
                        backdrop: 'transparent',
                        background: 'rgba(0,0,0,.75)',
                        customClass: {
                            icon: 'switch'
                        },
                        width: '28rem',
                        timer: 5000
                    }).then(() => {
                        history.push("/settings/type")
                    })
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    confirmButtonColor: "#f27474",
                    html: `<span class="colorWhite">${error.message}</span>`,
                    backdrop: 'transparent',
                    background: 'rgba(0,0,0,.75)',
                    customClass: {
                        icon: 'switch'
                    },
                    width: '28rem',
                    timer: 5000
                }).then(() => {
                    history.push("/settings/type")
                })
            })
    }, [_id])

    useEffect(() => {
        let id = document.getElementById("root")
        if (id) {
            id.style.height = "auto"
        }
        settingAPI.GetType(token)
            .then((res) => {
                if (res.status == 200) {
                    if (Array.isArray(res.message)) {
                        setType(res.message)
                    }
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${res.message}</span>`,
                        backdrop: 'transparent',
                        background: 'rgba(0,0,0,.75)',
                        customClass: {
                            icon: 'switch'
                        },
                        width: '28rem',
                        timer: 10000
                    }).then(() => {
                        setForce((old) => old + 1)
                    })
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    confirmButtonColor: "#f27474",
                    html: `<span class="colorWhite">${error.message}</span>`,
                    backdrop: 'transparent',
                    background: 'rgba(0,0,0,.75)',
                    customClass: {
                        icon: 'switch'
                    },
                    width: '28rem',
                    timer: 10000
                }).then(() => {
                    setForce((old) => old + 1)
                })
            })
        return () => {
            let id = document.getElementById("root")
            if (id) {
                id.style.height = "97vh"
            }
        }
    }, [force])

    const DropZoneComponents = (props) => {
        const activeStyle = {
            borderColor: "#2196f3",
        };

        const acceptStyle = {
            borderColor: "#00e676",
        };

        const rejectStyle = {
            borderColor: "#ff1744",
        };

        const { setFieldValue } = props

        const {
            acceptedFiles,
            fileRejections,
            getRootProps,
            getInputProps, isDragActive, isDragAccept, isDragReject
        } = useDropzone({
            multiple: false,
            onDrop: (acceptedFiles) => {
                setFieldValue("newFile", acceptedFiles[0])
            }
        });
        const style = useMemo(
            () => ({
                ...(isDragActive ? activeStyle : {}),
                ...(isDragAccept ? acceptStyle : {}),
                ...(isDragReject ? rejectStyle : {}),
            }),
            [isDragActive, isDragReject, isDragAccept]
        );
        const acceptedFileItems = acceptedFiles.map(file => (
            <li key={file.path}>
                {file.path} - {file.size} bytes
            </li>
        ));

        const fileRejectionItems = fileRejections.map(({ file, errors }) => {
            return (
                <li key={file.path}>
                    {file.path} - {file.size} bytes
                    <ul>
                        {errors.map(e => <li key={e.code}>{e.message}</li>)}
                    </ul>
                </li>
            )
        });

        return (
            <>
                <section className="container uploadBox" {...getRootProps({ style })}>
                    <div {...getRootProps({ className: 'dropzone' })}>
                        <input {...getInputProps()} />
                        <p>เลือกไฟล์หรือลากไฟล์เพื่ออัพโหลดไฟล์ (สูงสุด 1 ไฟล์)</p>
                    </div>
                </section>
                <aside>
                    {acceptedFiles.length >= 1 && <div>
                        <h5>Accepted files</h5>
                        <ul>{acceptedFileItems}</ul>
                    </div>}
                    {fileRejections.length >= 1 && <div>
                        <h5>Rejected files</h5>
                        <ul>{fileRejectionItems}</ul>
                    </div>}
                </aside>
            </>
        );
    }


    return (
        data && <Formik
            validationSchema={FormSchema}
            initialValues={{ ...data }}
            enableReinitialize
            onSubmit={async (values, { resetForm, setSubmitting }) => {
                try {
                    let mesard = ""
                    if (data.template_file_show != values.template_file_show) {
                        mesard = `ต้องการแก้ไขชื่อไฟล์จาก ${data.template_file_show} เป็น ${values.template_file_show} ?`
                    }
                    else {
                        mesard = `ต้องการแก้ไข ${values.template_file_show} ?`
                    }
                    if (!values.use) throw { message: 'เลือกกลุ่ม User ที่ใช้งานก่อน' }
                    if (!values.type) throw { message: 'เลือกประเภทของไฟล์ก่อน' }
                    Swal.fire({
                        title: 'คุณแน่ใจ ?',
                        text: mesard,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#56A834',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'แน่ใจ',
                        cancelButtonText: 'ยังก่อน'
                    })
                        .then(async (result) => {
                            try {
                                if (result.isConfirmed) {
                                    setSubmitting(true)
                                    let form = new FormData();
                                    form.append("_id", values._id)
                                    form.append("use", values.use)
                                    form.append("status", values.status ? "Active" : "Disable");
                                    form.append("type", values.type)
                                    form.append("template_file_show", values.template_file_show)
                                    if (values.newFile) {
                                        form.append("newFile", values.newFile)
                                    }
                                    settingAPI.EditTemplate(token, form)
                                        .then((res) => {
                                            if (res.status == 200) {
                                                Swal.fire({
                                                    icon: 'success',
                                                    confirmButtonColor: "#6ab23a",
                                                    html: `<span class="colorWhite">${res.message}</span>`,
                                                    backdrop: 'transparent',
                                                    background: 'rgba(0,0,0,.75)',
                                                    customClass: {
                                                        icon: 'switchZ'
                                                    },
                                                    width: '28rem',
                                                    timer: 3000
                                                }).then((res) => {
                                                    history.push("/settings/template")
                                                })
                                            }
                                            else {
                                                setSubmitting(false)
                                                Swal.fire({
                                                    icon: 'error',
                                                    confirmButtonColor: "#f27474",
                                                    html: `<span class="colorWhite">${res.message}</span>`,
                                                    backdrop: 'transparent',
                                                    background: 'rgba(0,0,0,.75)',
                                                    customClass: {
                                                        icon: 'switch'
                                                    },
                                                    width: '28rem',
                                                    timer: 3000
                                                })
                                            }
                                        })
                                        .catch((error) => {
                                            setSubmitting(false)
                                            Swal.fire({
                                                icon: 'error',
                                                confirmButtonColor: "#f27474",
                                                html: `<span class="colorWhite">${error.message}</span>`,
                                                backdrop: 'transparent',
                                                background: 'rgba(0,0,0,.75)',
                                                customClass: {
                                                    icon: 'switch'
                                                },
                                                width: '28rem',
                                                timer: 3000
                                            })
                                        })
                                }
                            }
                            catch (error) {
                                setSubmitting(false)
                                Swal.fire({
                                    icon: 'error',
                                    confirmButtonColor: "#f27474",
                                    html: `<span class="colorWhite">${error.message}</span>`,
                                    backdrop: 'transparent',
                                    background: 'rgba(0,0,0,.75)',
                                    customClass: {
                                        icon: 'switch'
                                    },
                                    width: '28rem',
                                    timer: 3000
                                })
                            }
                        })
                }
                catch (error) {
                    setSubmitting(false)
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${error.message}</span>`,
                        backdrop: 'transparent',
                        background: 'rgba(0,0,0,.75)',
                        customClass: {
                            icon: 'switch'
                        },
                        width: '28rem',
                        timer: 3000
                    })
                }
            }}
        >
            {({
                values,
                handleChange,
                setFieldValue,
                isSubmitting,
                touched,
                errors,
                resetForm
            }) => (
                <Form>
                    <Container style={{ padding: '20px', backgroundColor: '#ffffffbd', borderRadius: '10px' }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <h3><strong>แก้ไขไฟล์ Template <Refresh fontSize="small" style={{ cursor: 'pointer' }} onClick={() => resetForm({ ...values, ...data })} /></strong></h3>
                            </Grid>
                        </Grid>
                        <Container style={{ paddingTop: '1rem' }}>
                            <div className="row">
                                <div className="pt-5 col-lg-12">
                                    <div className="row">
                                        <div className="mt-4 col-lg-12">
                                            <TextField
                                                name="template_file_show"
                                                style={{ width: '100%' }}

                                                value={values.template_file_show}
                                                label="ชื่อไฟล์..."
                                                onChange={handleChange}
                                            />
                                            {errors.template_file_show && touched.template_file_show ? (
                                                <div style={{ color: "#FF3333" }}>{errors.template_file_show}</div>
                                            ) : null}
                                        </div>
                                        <div className="mt-4 col-lg-12">
                                            <label>
                                                <strong>Type</strong>
                                            </label>
                                            <Autocomplete
                                                options={type.map((res) => res.type_name)}
                                                onChange={(event, newValue) => {
                                                    setFieldValue("type", newValue)
                                                }}
                                                value={values.type}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Type Select..." variant="standard" value={values?.type || ""} />
                                                )}
                                            />
                                        </div>
                                        <div className="mt-4 col-12">
                                            <label>
                                                <strong>User Use</strong>
                                            </label>
                                            <Autocomplete
                                                options={["All", "Retail", "Support"]}
                                                onChange={(event, newValue) => {
                                                    setFieldValue("use", newValue)
                                                }}
                                                value={values.use}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="User Use Select..." variant="standard" value={values?.use || ""} />
                                                )}
                                            />
                                        </div>
                                        <div className="mt-4 col-12">
                                            <label>
                                                <strong>สถานะการใช้งาน</strong>
                                            </label>
                                            <FormGroup>
                                                <FormControlLabel control={<Checkbox checked={values.status} onClick={() => setFieldValue('status', true)} />} label="Active" />
                                                <FormControlLabel control={<Checkbox checked={!values.status} onClick={() => setFieldValue('status', false)} />} label="Disable" />
                                            </FormGroup>
                                        </div>
                                        <div className="mt-4 col-12">
                                            <DropZoneComponents setFieldValue={setFieldValue} />
                                        </div>
                                        <div className="mt-4 col-12">
                                            <Button variant="contained"
                                                type="submit"
                                                disabled={isSubmitting}
                                                style={{
                                                    border: "2px solid transparent",
                                                    backgroundColor: "#6ab23a",
                                                    borderRadius: "5px",
                                                    color: "white",
                                                    fontSize: "16px",
                                                    textDecoration: "none",
                                                    textTransform: "capitalize",
                                                }}>
                                                Submit
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </Container >
                </Form>)
            }
        </Formik >
    )
}

export default Setting_Edit_Template